import React  from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { getPostAuthRoute } from 'configs/AppConfig'

const PublicRoute = () => {
	const { token, user } = useSelector(state => state.auth)
	const location = useLocation()

	const storedUser = (() => {
		try {
			return JSON.parse(localStorage.getItem('auth_user') || 'null');
		} catch {
			return null;
		}
	})();
	const authUser = user || storedUser;
	
	const publicAccessRoutes = ['/', '/patient-checkin', '/patient-intake']
	const isPublicAccessRoute = publicAccessRoutes.includes(location.pathname)
	const isTokenRoute = /^\/(contract\/sign|pay|onboard|portal|memo)\//.test(location.pathname)
		|| location.pathname === '/grocery'
		|| location.pathname.startsWith('/grocery/')

	if (token && !isPublicAccessRoute && !isTokenRoute) {
		return <Navigate to={getPostAuthRoute(authUser)} />;
	}
  
	return <Outlet/>
}

export default PublicRoute
